import React from 'react';
import PropTypes from 'prop-types';
import ReactTransitionGroup from 'react-transition-group/CSSTransitionGroup';
/* helpers */
import { closestParentByTagName } from '../../utils/html-helper';
/* components */
import NavMenu from './nav-menu/nav-menu';
import Account from './account/account';
/* styles */
import './left-side-bar.scss';

export class LeftSideBar extends React.PureComponent {
    state = {
        isNavMenuExpanded: false,
        activeNavLinkName: ''
    };

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }

    toggleNavMenuExpanded = (isExpanded) => {
        let isNavMenuExpanded;
        if (typeof isExpanded === 'boolean') {
            isNavMenuExpanded = isExpanded;
        } else {
            isNavMenuExpanded = !this.state.isNavMenuExpanded;
        }
        this.setState({
            isNavMenuExpanded,
            activeNavLinkName: ''
        });
    };

    setActiveNavLinkName = (name) => {
        if (!name || this.state.activeNavLinkName === name) {
            this.setState({
                activeNavLinkName: '',
                isNavMenuExpanded: false
            });
        } else {
            this.setState({
                activeNavLinkName: name,
                isNavMenuExpanded: false
            });
        }
    };

    handleClickOutside = e => {
        if (e.cancelBubble) {
            return;
        }
        const isModalOpen = e.currentTarget
            && e.currentTarget.body
            && typeof e.currentTarget.body.className === 'string'
            && e.currentTarget.body.className.indexOf('sten-modal--opened') > -1;
        const targetButton = closestParentByTagName(e.target, 'button');
        const isKeyboardClick = targetButton && typeof targetButton.className === 'string'
            && targetButton.className.indexOf('keyboard-button') > -1;
        if ((this.state.isNavMenuExpanded || this.state.activeNavLinkName)
            && !isModalOpen
            && !isKeyboardClick
            && (!this.leftSideMenuRef || !this.leftSideMenuRef.contains(e.target))
        ) {
            this.toggleNavMenuExpanded(false);
            this.setActiveNavLinkName('');
        }
    };

    saveRef = (c) => { this.leftSideMenuRef = c; };

    getPanelComponent() {
        switch (this.state.activeNavLinkName) {
        case 'account':
            return (
                <Account
                    key="account"
                    name={this.props.name}
                    pathName={this.props.pathName}
                    isExternalAccount={this.props.isExternalAccount}
                />
            );
        default:
            return '';
        }
    }

    render() {
        let sidebarItemClassName = 'sten-left-sidebar__item sten-left-sidebar__collapsible-item';
        if (!this.state.activeNavLinkName) {
            sidebarItemClassName += ' sten-left-sidebar__collapsible-item--collapsed';
        }
        return (
            <aside className="sten-left-sidebar clearfix" ref={this.saveRef}>
                <div className="sten-left-sidebar__item">
                    <NavMenu
                        isExpanded={this.state.isNavMenuExpanded}
                        toggleExpand={this.toggleNavMenuExpanded}
                        activeLinkName={this.state.activeNavLinkName}
                        setActiveLink={this.setActiveNavLinkName}
                        name={this.props.name}
                        pathName={this.props.pathName}
                        isExternalAccount={this.props.isExternalAccount}
                        tenantInfo={this.props.tenantInfo}
                    />
                </div>
                <div className={sidebarItemClassName}>
                    <ReactTransitionGroup
                        component="div"
                        className="sten-left-sidebar__panels-container"
                        transitionName="transition-fade"
                        transitionEnterTimeout={500}
                        transitionLeaveTimeout={500}
                    >
                        {this.getPanelComponent()}
                    </ReactTransitionGroup>
                </div>
            </aside>
        );
    }
}

LeftSideBar.propTypes = {
    name: PropTypes.string,
    pathName: PropTypes.string,
    tenantInfo: PropTypes.objectOf(PropTypes.any),
    isExternalAccount: PropTypes.bool
};

LeftSideBar.defaultProps = {
    name: '',
    pathName: '',
    tenantInfo: null,
    isExternalAccount: false
};

export default LeftSideBar;
